export default "__VITE_ASSET__9tW5c23s__"